export const saveSiteId = siteId => {
    zibi.set_currentSite(siteId);
};

export const getSiteId = () => {
    return zibi.currentSite;
};